export var dark = {
  primary: '#E7E7E7',
  secondary: '#B3C6D8',
  third: '#526079',
  fourth: '#2D3446',
  fifth: '#1E2534',
  base: '#171E2D',
  background: '#121927'
};